export const SYSTEM_AVATARS = [
  { id: "avatar-01", key: "avatar-01", url: "/Avatars/1.webp" },
  { id: "avatar-02", key: "avatar-02", url: "/Avatars/2.webp" },
  { id: "avatar-03", key: "avatar-03", url: "/Avatars/3.webp" },
  { id: "avatar-04", key: "avatar-04", url: "/Avatars/4.webp" },
  { id: "avatar-05", key: "avatar-05", url: "/Avatars/5.webp" },
  { id: "avatar-06", key: "avatar-06", url: "/Avatars/6.webp" },
  { id: "avatar-07", key: "avatar-07", url: "/Avatars/7.webp" },
  { id: "avatar-09", key: "avatar-09", url: "/Avatars/9.webp" },
  { id: "avatar-10", key: "avatar-10", url: "/Avatars/10.webp" },
  { id: "avatar-11", key: "avatar-11", url: "/Avatars/11.webp" },
  { id: "avatar-12", key: "avatar-12", url: "/Avatars/12.webp" },
] as const;

export type SystemAvatar = (typeof SYSTEM_AVATARS)[number];

/** True when URL is a built-in preset under /Avatars (not user uploads). */
export function isSystemAvatarUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  return SYSTEM_AVATARS.some((avatar) => avatar.url === url);
}
